import { useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const FIELDS = [
  { key: "fullName", label: "Full Name", type: "text", testId: "contact-form-full-name" },
  { key: "companyName", label: "Company Name", type: "text", testId: "contact-form-company-name" },
  { key: "country", label: "Country", type: "text", testId: "contact-form-country" },
  { key: "email", label: "Email", type: "email", testId: "contact-form-email" },
  { key: "phone", label: "Phone / WhatsApp", type: "text", testId: "contact-form-phone" },
  { key: "productRequired", label: "Product Required", type: "text", testId: "contact-form-product-required" },
  { key: "quantityRequired", label: "Quantity Required", type: "text", testId: "contact-form-quantity-required" },
  { key: "destination", label: "Destination", type: "text", testId: "contact-form-destination" },
];

const initialForm = FIELDS.reduce((acc, f) => ({ ...acc, [f.key]: "" }), { message: "" });

export const InquiryForm = () => {
  const [form, setForm] = useState(initialForm);

  const handleChange = (key) => (e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.info("This form is not yet connected to a backend.", {
      description: "Please reach us directly using the phone, WhatsApp or email details on this page.",
    });
  };

  return (
    <section data-testid="contact-inquiry-form-section" className="bg-white">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[#042D1F] mb-8">
          Request a Quote / Inquiry
        </h2>
        <form data-testid="contact-inquiry-form" onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {FIELDS.map((field) => (
            <div key={field.key} className="space-y-1.5">
              <Label htmlFor={field.testId}>{field.label}</Label>
              <Input
                id={field.testId}
                data-testid={field.testId}
                type={field.type}
                value={form[field.key]}
                onChange={handleChange(field.key)}
              />
            </div>
          ))}
          <div className="sm:col-span-2 space-y-1.5">
            <Label htmlFor="contact-form-message">Message / Requirement</Label>
            <Textarea
              id="contact-form-message"
              data-testid="contact-form-message"
              rows={4}
              value={form.message}
              onChange={handleChange("message")}
            />
          </div>
          <div className="sm:col-span-2">
            <Button
              type="submit"
              data-testid="contact-form-submit"
              className="bg-[#0B4F37] hover:bg-[#042D1F] text-white font-semibold rounded-full px-7"
            >
              Submit Enquiry
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};
